export default {
    computed: {
        scheduledDateTime: {
            get: function() {
                return this.getScheduleAt(
                    this.scheduledDateDate,
                    this.scheduledTime
                )
            },
            set: function(value) {
                console.log('getter called')
                const [date, time] = (value || ' ').split(' ')
                this.scheduledDateDate = date
                this.scheduledTime = time
            },
        },
    },
    methods: {
        getScheduleAt(date, time) {
            const st = `${date} ${time
                .split(':')
                .slice(0, 2)
                .join(':')}:00`
            console.log('getScheduleAt', st)
            return st
        },

        getScheduleAtParts(value) {
            console.log('getter called')
            const [date, time] = (value || ' ').split(' ')
            return {date, time}
        },
    },
}
